// Module
var code = "<span title=\"{{'Level'|translate}} {{vm.level + 1}}\">{{'Level'|translate|limitTo:1}}{{vm.level + 1}}</span>";
// Exports
module.exports = code;